// @flow

export default {
  computed: {
    hasInfoText (): boolean {
      return this.option.infoText?.title || this.option.infoText?.description || this.option.isDisabled
    },
    infoIcon (): string {
      if (this.option.isDisabled) return 'question'

      return 'info'
    },
    infoTitle (): string {
      if (this.option.isDisabled) return ''

      return this.option.infoText.title
    },
    infoDescription (): string {
      if (this.option.isDisabled) return this.$t('recommender.answerOptionLeadsToNoRecommendation')

      return this.option.infoText.description
    }
  }
}
